import type { ReactNode } from 'react';
import React from 'react';

import { useSmartCardContext } from '@atlaskit/link-provider/use-smart-card-context';

import { ConfluenceSmartCardProvider } from '@confluence/smart-card-provider/entry-points/ConfluenceSmartCardProvider.tsx';

/**
 * Gives the suggestion source cards a smart card provider. Reuses the editor's provider in edit
 * mode and live docs in view mode, and adds one on published pages, which have none above the sidebar.
 */
export function SuggestionsSmartCardProvider({
	children,
}: {
	/** The panel content that renders smart cards. */
	children: ReactNode;
}): React.JSX.Element {
	const hasSmartCardProvider = !!useSmartCardContext().value;

	if (hasSmartCardProvider) {
		return <>{children}</>;
	}
	return <ConfluenceSmartCardProvider>{children}</ConfluenceSmartCardProvider>;
}
